import { ROOT_NODE, type SerializedNode, useEditor } from '@craftjs/core';
import { useState } from 'react';
import { selectIsFeatureEnabled } from '@/store/featureFlags/selectors';
import { useAppSelector } from '@/store/hooks';
import { AI_GENERATION_LOADER_NODE_NAME } from '@/utils/constants';
export const useCraftSerialization = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const isAiBuilderEnabled = useAppSelector(selectIsFeatureEnabled('builder4-ai-builder'));
  const { query } = useEditor();

  const saveCraftJson = () => {
    setIsLoading(true);
    setError(null);
    try {
      let craftJson = query.serialize();
      craftJson = prepareJsonForSave(craftJson, isAiBuilderEnabled);
      return craftJson;
    } catch (err) {
      console.error('Serialization error:', err);
      throw new Error('Failed to serialize CraftJS state');
    } finally {
      setIsLoading(false);
    }
  };

  function prepareJsonForSave(craftJson: string, filterAiLoader: boolean): string {
    const cloned = JSON.parse(craftJson) as Record<string, SerializedNode>;

    // Remove AI loader node if present (filter by displayName)
    // The feature flag check avoids running these checks on every save
    // in environments where the loader would never be present anyway
    if (filterAiLoader) {
      const loaderIds = Object.keys(cloned).filter(
        (id) => cloned[id].displayName === AI_GENERATION_LOADER_NODE_NAME,
      );
      for (const loaderId of loaderIds) {
        delete cloned[loaderId];
        // Also remove from ROOT's children array
        if (cloned[ROOT_NODE]?.nodes) {
          cloned[ROOT_NODE].nodes = cloned[ROOT_NODE].nodes.filter((id: string) => id !== loaderId);
        }
      }
    }
    //always set to desktop breakpoint for root node as on load redux always have desktop breakpoint
    cloned[ROOT_NODE].props.breakpoint = 'desktop';

    return JSON.stringify(cloned);
  }

  return {
    saveCraftJson,
    isLoading,
    error,
    clearError: () => setError(null),
  };
};
